"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawerBody = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var core_1 = require("@material-ui/core");
var DrawerNavGroup_1 = require("./DrawerNavGroup");
var types_1 = require("./types");
var utilities_1 = require("./utilities");
var clsx_1 = __importDefault(require("clsx"));
var useStyles = core_1.makeStyles({
    root: {
        display: 'flex',
        flex: '1 1 0px',
        flexDirection: 'column',
        overflowY: 'auto',
        backgroundColor: function (props) { return props.backgroundColor; },
    },
});
var DrawerBodyRender = function (bodyProps, ref) {
    var defaultClasses = useStyles(bodyProps);
    var 
    // Inheritable Props
    activeItemBackgroundColor = bodyProps.activeItemBackgroundColor, activeItemBackgroundShape = bodyProps.activeItemBackgroundShape, activeItemFontColor = bodyProps.activeItemFontColor, activeItemIconColor = bodyProps.activeItemIconColor, backgroundColor = bodyProps.backgroundColor, chevron = bodyProps.chevron, collapseIcon = bodyProps.collapseIcon, disableActiveItemParentStyles = bodyProps.disableActiveItemParentStyles, divider = bodyProps.divider, expandIcon = bodyProps.expandIcon, hidePadding = bodyProps.hidePadding, itemFontColor = bodyProps.itemFontColor, itemIconColor = bodyProps.itemIconColor, nestedBackgroundColor = bodyProps.nestedBackgroundColor, nestedDivider = bodyProps.nestedDivider, ripple = bodyProps.ripple, 
    // DrawerBody-specific props
    classes = bodyProps.classes, bodyChildren = bodyProps.children, 
    // Other div props
    otherDivProps = __rest(bodyProps, ["activeItemBackgroundColor", "activeItemBackgroundShape", "activeItemFontColor", "activeItemIconColor", "backgroundColor", "chevron", "collapseIcon", "disableActiveItemParentStyles", "divider", "expandIcon", "hidePadding", "itemFontColor", "itemIconColor", "nestedBackgroundColor", "nestedDivider", "ripple", "classes", "children"]);
    var children = react_1.default.Children.toArray(bodyChildren);
    return (react_1.default.createElement("div", __assign({ ref: ref, className: clsx_1.default(defaultClasses.root, classes.root) }, otherDivProps), children.map(function (child, index) {
        if (!child) {
            return null;
        }
        if (child.type && child.type.displayName !== 'DrawerNavGroup')
            return child;
        var groupProps = child.props;
        return (react_1.default.createElement(DrawerNavGroup_1.DrawerNavGroup, __assign({ key: "NavGroup_" + index }, groupProps, { activeItemBackgroundColor: utilities_1.mergeStyleProp(activeItemBackgroundColor, groupProps.activeItemBackgroundColor), activeItemBackgroundShape: utilities_1.mergeStyleProp(activeItemBackgroundShape, groupProps.activeItemBackgroundShape), activeItemFontColor: utilities_1.mergeStyleProp(activeItemFontColor, groupProps.activeItemFontColor), activeItemIconColor: utilities_1.mergeStyleProp(activeItemIconColor, groupProps.activeItemIconColor), backgroundColor: utilities_1.mergeStyleProp(backgroundColor, groupProps.backgroundColor), chevron: utilities_1.mergeStyleProp(chevron, groupProps.chevron), collapseIcon: utilities_1.mergeStyleProp(collapseIcon, groupProps.collapseIcon), disableActiveItemParentStyles: utilities_1.mergeStyleProp(disableActiveItemParentStyles, groupProps.disableActiveItemParentStyles), divider: utilities_1.mergeStyleProp(divider, groupProps.divider), expandIcon: utilities_1.mergeStyleProp(expandIcon, groupProps.expandIcon), hidePadding: utilities_1.mergeStyleProp(hidePadding, groupProps.hidePadding), itemFontColor: utilities_1.mergeStyleProp(itemFontColor, groupProps.itemFontColor), itemIconColor: utilities_1.mergeStyleProp(itemIconColor, groupProps.itemIconColor), nestedBackgroundColor: utilities_1.mergeStyleProp(nestedBackgroundColor, groupProps.nestedBackgroundColor), nestedDivider: utilities_1.mergeStyleProp(nestedDivider, groupProps.nestedDivider), ripple: utilities_1.mergeStyleProp(ripple, groupProps.ripple) })));
    })));
};
/**
 * [DrawerBody](https://pxblue-components.github.io/react/?path=/info/components-drawer--get-read-me-story) component
 *
 * The `<DrawerBody>` is a wrapper for the main content of the Drawer. The typical use case is to display `<DrawerNavGroup>` elements, but custom elements (e.g., for spacing) are accepted as well.
 */
exports.DrawerBody = react_1.default.forwardRef(DrawerBodyRender);
exports.DrawerBody.displayName = 'DrawerBody';
// @ts-ignore
exports.DrawerBody.propTypes = __assign(__assign(__assign({}, types_1.SharedStylePropTypes), types_1.NavItemSharedStylePropTypes), { classes: prop_types_1.default.shape({
        root: prop_types_1.default.string,
    }) });
exports.DrawerBody.defaultProps = {
    classes: {},
};
